export default "__VITE_ASSET__9tm0qNj3__"